import { TransactionService } from "appworks/services/transaction/transaction-service";
import { Contract } from "appworks/utils/contracts/contract";

export class AgsTransactionService extends TransactionService {
    public setWinnings(currentWin: number, totalWin?: number, tickTime: number = 0): Contract<void> {
        return super.setWinnings(currentWin, totalWin, tickTime);
    }

    public setBalance(value: number) {
        super.setBalance(value);
    }
}
